/** Ollama Tunnel 集成；HTTPS 公网域名及 Access 服务令牌，明文只提交不回显。 */
import { z } from 'zod';

export const OllamaBaseUrlSchema = z
  .string()
  .trim()
  .max(512)
  .refine((value) => {
    const match = /^https:\/\/((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63})\/v1$/.exec(
      value,
    );
    return !!match && !/(?:^|\.)(?:localhost|local|internal|lan)$/.test(match[1] ?? '');
  }, '请输入 Cloudflare Tunnel HTTPS 地址（以 /v1 结尾，不能使用本机或内网地址）');

export const UpsertOllamaCredentialRequestSchema = z
  .object({
    base_url: OllamaBaseUrlSchema,
    access_client_id: z.string().trim().min(1).max(256),
    access_client_secret: z.string().trim().min(16).max(512).optional(),
    timeout_seconds: z.number().int().min(30).max(120).default(60),
  })
  .strict();
export type UpsertOllamaCredentialRequest = z.input<typeof UpsertOllamaCredentialRequestSchema>;
export type OllamaCredentialResponse = {
  configured: boolean;
  base_url: string | null;
  access_client_id: string | null;
  secret_tail: string | null;
  timeout_seconds: number | null;
  last_verified_at: string | null;
  updated_at: string | null;
};
